<template>
    <div class="page">
        <mobileHeader title="电子合格证" rightType="none" />
        <div class="form-box">
            <div class="form-item">
                <div class="form-title">{{ detail.porder.user_name }} {{ detail.porder.user_phone }} <div
                        class="orange-tag">{{ getUserGroup(detail.user_group) }}</div>
                </div>
                <div class="form-subtitle">{{ detail.porder.address }}</div>
                <div class="form-subtitle">下单时间：{{ detail.porder.created_at }}</div>
                <div class="form-subtitle color-red">备注：{{ detail.porder.remarks || '--' }}</div>
            </div>
            <div class="form-item">
                <div class="form-title">用户反馈图</div>
                <div class="form-label">
                    <img :src="it" class="upload-file" v-for="(it, i) in detail.porder.feedback">
                </div>
            </div>
            <block v-if="designData && designData.staff">
                <div class="form-item">
                    <div class="form-title">设计前</div>
                    <div class="form-label">
                        <img :src="it" alt="" class="upload-file" v-for="(it, i) in designData.before">
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-title">设计后</div>
                    <div class="form-label">
                        <img :src="it" alt="" class="upload-file" v-for="(it, i) in designData.after">
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-title">设计服务费 </div>
                    <div class="history-item color-red" style="text-align: end">￥{{ designData.staff_fee }}</div>
                </div>
                <div class="form-item">
                    <div class="form-title">设计作业人员</div>
                    <div class="history-item">【{{ designData.staff }}】 备注：{{ designData.staff_remark }} </div>
                </div>
                <div class="form-item">
                    <div class="form-title">客户签名</div>
                    <div class="form-autograph">
                        <img style="margin: auto;" :src="designData.signature" class="upload-file">
                    </div>
                </div>
            </block>

            <block v-if="pipeData && pipeData.staff">
                <!-- 一级 item -->
                <div class="form-item" v-for="(item, itemindex) in pipeItem">
                    <div class="form-title">{{ item.item }}</div>
                    <!-- 二级 it -->
                    <div class="form-cell" v-for="(it, itindex) in item.children">
                        <div class="form-cell-label">{{ it.item }}</div>
                        <div class="form-cell-value">
                            <div class="form-cell-value-radio">
                                <!-- 三级 tt -->
                                <div :class="pipeVal.indexOf(tt.id) != -1 ? 'form-radio-item form-radio-item-act' : 'form-radio-item'"
                                    v-for="(tt, ttindex) in it.children">
                                    <span></span>{{ tt.item }}
                                </div>
                            </div>
                            <!-- <div class="form-cell-value-check" v-if="it.check_type === 2">
                                三级 tt 多选
                                <div class="form-check-item" v-for="(tt, ttindex) in it.children">
                                    <img class="upload-file"
                                        :src="pipeVal.indexOf(tt.id) != -1 ? '~/assets/images/check/act.png' : '~/assets/images/check/no.png'">{{
                                            tt.item }}
                                </div>
                            </div> -->
                            <div class="form-label">
                                <img class="upload-file" :src="p" alt="" v-for="(p) in pipeCheckImg[it.id]">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-title">管道耗材 </div>
                    <div class="history-item" v-for="(item) in pipeData.record">【{{ item.good_name }} x {{ item.number
                    }}】 ￥{{ item.good_price * item.number }}</div>
                </div>
                <div class="form-item">
                    <div class="form-title">管道费用 </div>
                    <div class="history-item color-red">【服务费】￥{{ pipeData.staff_fee }} 【耗材费】￥{{ pipeData.goods_fee }}
                        【总计】 ￥{{ pipeData.total_amount }}</div>
                </div>
                <div class="form-item">
                    <div class="form-title">管道作业人员</div>
                    <div class="history-item">【{{ pipeData.staff }}】 备注：{{ pipeData.staff_remark }} </div>
                </div>
                <div class="form-item">
                    <div class="form-title">客户签名</div>
                    <div class="form-autograph">
                        <img style="margin: auto;" :src="pipeData.signature" class="upload-file">
                    </div>
                </div>
            </block>
            <block v-if="devData && devData.staff">
                <div class="form-item" v-for="(it, i) in devCheck">
                    <div class="form-title">器具清单 【{{ getDevType(it.type) }}】 {{ it.brand }} {{ it.model }} </div>
                    <!-- 二级 it -->
                    <div class="form-cell" v-for="(it_c) in it.type == 1 ? devItem[0].children : devItem[1].children">
                        <div class="form-cell-label">{{ it_c.item }}</div>
                        <div class="form-cell-value">
                            <div class="form-cell-value-radio" v-if="it_c.check_type === 1">
                                <!-- 三级 tt 单选 -->
                                <div :class="devVal.indexOf(tt.id) != -1 ? 'form-radio-item form-radio-item-act' : 'form-radio-item'"
                                    v-for="(tt, ttindex) in it_c.children">
                                    <span></span>{{ tt.item }}
                                </div>
                            </div>
                            <div class="form-label">
                                <img class="upload-file" :src="p" alt="" v-for="(p) in devCheckImg[it_c.id]">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-title">器具安装耗材 </div>
                    <div class="history-item" v-for="(item) in devData.record">【{{ item.good_name }} x {{ item.number
                    }}】 ￥{{ item.good_price * item.number }}</div>
                </div>
                <div class="form-item">
                    <div class="form-title">器具安装费用 </div>
                    <div class="history-item color-red">【服务费】￥{{ devData.staff_fee }} 【耗材费】￥{{ devData.goods_fee }}
                        【总计】 ￥{{ devData.total_amount }}</div>
                </div>
                <div class="form-item">
                    <div class="form-title">器具安装作业人员</div>
                    <div class="history-item">【{{ devData.staff }}】 备注：{{ devData.staff_remark }} </div>
                </div>
                <div class="form-item">
                    <div class="form-title">客户签名</div>
                    <div class="form-autograph">
                        <img class="upload-file" style="margin: auto;" :src="devData.signature">
                    </div>
                </div>
            </block>
        </div>
    </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import { Toast } from 'vant';
import { getGasOrderDetail, getNaturalPipeItem } from "../../api/gasCer";
export default {
    components: { mobileHeader },
    data() {
        return {
            pipeItem: [],
            detail: {},
            designData: {},
            pipeData: {},
            pipeVal: [],
            pipeCheckImg: [],
            pipePic: [],
            devData: {},
            devVal: [],
            devCheckImg: [],
            devCheck: [],
        }
    },
    created() {
        this.getDetail()
    },

    methods: {
        async getDetail() {
            const { uid } = this.$route.query
            const { code, msg, data } = await getGasOrderDetail(uid)
            if (code != 200) return Toast({ message: msg, duration: 500 })
            this.detail = data
            //设计
            if (data.design) {
                this.designData = {
                    staff: data.design.staff,
                    staff_fee: data.design.staff_fee,
                    staff_remark: data.design.staff_remark,
                    signature: data.design.signature,
                    before: JSON.parse(data.design.before),
                    after: JSON.parse(data.design.after)
                }
            }
            //管道
            if (data.pipe) {
                this.pipeData = {
                    staff: data.pipe.staff,
                    staff_fee: data.pipe.staff_fee,
                    goods_fee: data.pipe.goods_fee,
                    total_amount: data.pipe.total_amount,
                    staff_remark: data.pipe.staff_remark,
                    signature: data.pipe.signature,
                    record: data.pipe.record
                }
                //管道施工项表格
                this.getNaturalPipeItem()
            }
            //器具安装
            if (data.dev) {
                this.devData = {
                    staff: data.dev.staff,
                    staff_fee: data.dev.staff_fee,
                    goods_fee: data.dev.goods_fee,
                    total_amount: data.dev.total_amount,
                    staff_remark: data.dev.staff_remark,
                    signature: data.dev.signature,
                    record: data.dev.record
                }
                //器具施工项表格
                this.getNaturalDevItem()
            }
        },
        async getNaturalPipeItem() {
            const { code, msg, data } = await getNaturalPipeItem({ type: 5 })
            if (code != 200) return Toast({ message: msg, duration: 500 })
            this.pipeItem = data //表格项
            let pipeVal = []
            let checkImg = [];

            //处理选中图片,id
            let pipeCheck = this.detail.pipe.check ? JSON.parse(this.detail.pipe.check) : []
            pipeCheck.forEach((it) => {
                it.sel.forEach((itt) => {
                    pipeVal.push(itt.id)
                    if (itt.pic.length > 0) {
                        checkImg[it.top_id] = itt.pic;
                    }
                })
            });
            this.pipeVal = pipeVal
            this.pipeCheckImg = checkImg
        },

        async getNaturalDevItem() {
            const { code, msg, data } = await getNaturalPipeItem({ type: '6,7' })
            if (code != 200) return Toast({ message: msg, duration: 500 })
            this.devItem = data
            let devVal = []
            let checkImg = []
            const check = this.detail.dev.check ? JSON.parse(this.detail.dev.check) : []
            const checkDev = check.gas_dev ? check.gas_dev : []
            checkDev.forEach((it) => {
                it.check_item = it.check_item ? it.check_item : []
                it.check_item.forEach((itt) => {
                    itt.sel.forEach((ittt) => {
                        devVal.push(ittt.id)
                        if (ittt.pic.length > 0) {
                            checkImg[itt.top_id] = ittt.pic
                        }
                    })
                })
            });
            this.devVal = devVal
            this.devCheckImg = checkImg
            this.devCheck = checkDev
        },


        getUserGroup(group) {
            if (group == '1') return '液化气'
            if (group == '2') return '液化气'
            if (group == '3') return '天然气'
        },

        getDataType(data_type, order_type, order_step) {
            if (data_type == 'agent_order') {
                if (order_type == 0) return "上门维修"
                else {
                    return "燃气改造-" + (order_step == '1' ? '设计工序' : (order_step == '2' ? '管道工序' : '器具安装'))
                }
            }
            if (data_type == 'indoor_order') return "入户安检"
        },
        getDevType(type) {
            if (type == '1') return '灶具'
            if (type == '2') return '热水器'
            if (type == '3') return '热水炉'
            if (type == '4') return '商业燃烧器具'
        },
    }
};

</script>
<style lang="scss" scoped>
.page {
    font-size: 20px;
    box-sizing: border-box;
    color: #444444;
}

.form-box {
    background: #f5f4f8;
    padding: 20px;
}

.form-item {
    background: white;
    border-radius: 16px;
    padding: 16px;
    margin-bottom: 16px;
    position: relative;
}

.form-title {
    padding-left: 20px;
    position: relative;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.form-title::before {
    content: "";
    width: 5px;
    height: 100%;
    left: 5px;
    position: absolute;
    background: #1f97f1;
    border-radius: 10px;
}

.form-label {
    padding-left: 5px;
}

.form-subtitle {
    font-size: 16px;
    margin-top: 15px;
    padding: 0px 20px;
    width: 80vw;
}

.upload-file {
    padding: 15px 10px 0px 0px;
    width: 100px;
}

.form-cell {
    font-size: 13px;
    display: flex;

}

.form-cell-label {
    width: 150px;
    min-width: 150px;
    text-align: end;
    padding: 10px 0;
}

.form-cell-value {
    width: calc(100% - 160px);
    color: rgb(77, 76, 76);
}

.form-cell-text {
    padding: 10px 0;
    padding-left: 20px;
    color: rgb(77, 76, 76);
}

.form-cell-value-radio,
.form-cell-value-check {
    display: flex;
    flex-wrap: wrap;
    //   padding-left: 20px;
}

.form-radio-item,
.form-check-item {
    width: fit-content;
    padding-left: 42px;
    position: relative;
    line-height: 40px;
}

.form-radio-item>span {
    width: 16px;
    height: 16px;
    position: absolute;
    left: 20px;
    top: 12px;
    border: 1px solid #ccc;
    border-radius: 50px;
    box-sizing: border-box;
}

.form-radio-item-act>span {
    border: 1px solid #248ee4;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-radio-item-act>span::after {
    content: "";
    width: 8px;
    height: 8px;
    background: #248ee4;
    border-radius: 50px;
}

.form-autograph {
    display: flex;
    flex-direction: column;
}

.form-autograph-but {
    margin: auto;
    border: 4px solid #6acefc;
    width: fit-content;
    padding: 10px;
    color: #6acefc;
    font-weight: 600;
}

.orange-tag {
    background: #e26430;
    color: white;
    padding: 1px 16px;
    border-radius: 10px;
    font-size: 14px;
}

.color-red {
    color: #de2529;
}

.phone {
    width: 60px;
    height: 60px;
    position: absolute;
    right: 30px;
    bottom: 50px;
}

.history-item {
    font-size: 16px;
    position: relative;
    margin: 20px 0;
}

.is-null {
    color: #ccc;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    font-size: 25px;
}

.is-null>image {
    width: 100px;
    height: 100px;
}

.transfer-order {
    background: #f38f2f;
    position: fixed;
    font-size: 26px;
    right: 200px;
    bottom: 100px;
    padding: 8px 30px;
    color: white;
    border-radius: 8px;
    transition: all .4s;
}

.handle-button {
    background: #2593fb;
    position: fixed;
    font-size: 26px;
    right: 30px;
    bottom: 100px;
    padding: 8px 30px;
    color: white;
    border-radius: 8px;
    transition: all .4s;
}

.handle-button:active {
    background: #bb7c40;
}


.select-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9;
}

.mask {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.705);
}

.gas_cer {
    width: 80px;
    height: 80px;
    position: absolute;
    right: 10px;
    bottom: 8px;
}
</style>